export const wrapEmailsWithTag = (
  text: string,
  htmlTag: keyof HTMLElementTagNameMap = 'strong'
): string => {
  const pattern = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
  return text.replace(pattern, `<${htmlTag}>$&</${htmlTag}>`);
};

export const isCastEmail = (text?: string): boolean =>
  text != undefined && /^.+@(cast.ai|castai.co)$/i.test(text);
